export default {
  discount: false,
  tax: false,
  reedemPoints: false,
  roundOff: false,
  paidAmount: false,
  prepaidAmount: false,
  otherCharges: false,
  coupon: false,
  imei: false,
  itemMRP: false,
  itemDiscount: false,
  itemWastage: false,
  itemLabour: false,
  hsnCode: false,
  itemLevelTax: false,
  billingAddress: false,
  shippingAddress: false,
  termsAndCondition: false,
  paymentTerms: false,
  dueDate: false,
  invoicePrefix: false,
  employee: false,
  modeOfPayment: false,
  addRemainder: false,
  tAndCField: "",
  paymentTermsField: "",
  invoicePrefixField: "",
  invoiceSuffixField: "202100",
  currentInvoiceNumber: "202100",
  otherChargesField: [],
  printerType: "Thermal",
  invoiceTemplate: "template2",
};
